// Same pattern used by helpers/renderer/posterRenderer.js for the poster background's
// YouTube video option — kept identical here so both features parse pasted URLs the same way.
const YOUTUBE_ID_RE = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;

export function extractYouTubeId(url) {
  if (!url || typeof url !== 'string') return null;
  const match = url.match(YOUTUBE_ID_RE);
  return match ? match[1] : null;
}

export function youTubeThumbnailUrl(url) {
  const id = extractYouTubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}
